"use client";

import NewsListBlock from "@/components/blocks/NewsListBlock/NewsListBlock";
import { fetchRelatedNews } from "@/services/newsService";
import { useQuery } from "@tanstack/react-query";
import { useParams, usePathname } from "next/navigation";
import { getLabel } from "@/data/labels";
import { getLocaleFromPathname } from "@/utils/getLocaleFromPath";

export default function RelatedNewsList() {
  const { "post-slug": postSlug } = useParams();
  const pathname = usePathname();
  const locale = getLocaleFromPathname(pathname) || "te-IN";
  const language = locale?.split("-")[0] || "en";

  const { data } = useQuery({
    queryKey: ["fetchRelatedNews", postSlug],
    queryFn: () => fetchRelatedNews({ slug: postSlug.toString(), limit: 8 }),
  });

  return (
    <div>
      <NewsListBlock
        articles={data || []}
        block={{
          id: "",
          blockType: "",
          category: "",
          limit: 8,
          orderBy: "latest",
          title: getLabel(language, "RELATED_NEWS"),
          maxColumns: 2,
          showDate: true,
          showCategory: true,
          showViewMore: false,
        }}
      />
    </div>
  );
}
